import CarTypeListPage from "../pages/car_type/carTypeIndex";
import AddCarType from "../pages/car_type/carTypeAdd";
import EditCarType from "../pages/car_type/carTypeEdit";

const carTypeRoutes = [
  {
    path: "car_type",
    element: <CarTypeListPage />,
  },
  {
    path: "car_type/add",
    element: <AddCarType />,
  },
  {
    path: "car_type/edit/:id",
    element: <EditCarType />,
  },
];

export default carTypeRoutes;